import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function DirectInstruction({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-4.5 -1 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g
        className={theme.stroke}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M1.33133333 26.1852364H30.5333333V5.96776364H1.33133333zM15.9322667.61258545v5.16183637M8.47233333 36.9398582l7.45999997-10.3243455v10.3243455M23.4824 36.9398582l-7.46-10.3243455" />
        <path d="M5.5156 10.6279473h20.326v11.5904182" />
      </g>
    </svg>
  )
}

DirectInstruction.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
